import axiosInstance from "app/axiosInstance";

class AlarmsService {
  static getAlarmTypes = async () => {
    return await axiosInstance.get(`/AlarmTypes`);
  };
}

export default AlarmsService;
